// One sheet line's own handwriting, under "From sheet, line N" (O180; shape O181: the
// row's top and bottom in per-mille of the page). The read says where the row sits on its
// page (lib/refill-sheet lineCrop); this draws that band of
// the page image — the SAME image the model read, from the page route the viewer already
// uses (GET /api/sms/chat/roster/:id/pages/:n, uploader-scoped, never cached) — at the
// card's width. No new route and nothing new in a URL. The browser loads it lazily, and
// every crop of one page is the same image URL, which the browser reuses within the
// document (measured in Chrome: five crops and the viewer → one request).
//
// The band is the full page width, so every column of the row shows; its height comes
// from the image's own size once it has loaded (a letter page until then). A click opens
// the page viewer on that page, with the row highlighted. An image that will not load
// leaves only the "View on the sheet" link, as before.
import React, { useId, useState } from 'react';
import { cropLayout, sheetPageUrl } from '../../lib/refill-sheet.js';

export function LineCrop({ rosterId, line, crop, onOpen }) {
  const [natural, setNatural] = useState(null);
  const [failed, setFailed] = useState(false);
  const hintId = `rs-crop-hint-${useId()}`;
  const layout = crop ? cropLayout(crop.view, natural, crop.band) : null;
  if (!crop || !layout || failed) return null;
  const measure = (img) => {
    if (img && img.naturalWidth > 0 && img.naturalHeight > 0
      && (!natural || natural.width !== img.naturalWidth || natural.height !== img.naturalHeight)) {
      setNatural({ width: img.naturalWidth, height: img.naturalHeight });
    }
  };
  return (
    <button
      type="button"
      className="rs-crop"
      data-role="line-crop"
      aria-describedby={hintId}
      onClick={onOpen}
    >
      <span className="rs-crop-frame" style={{ aspectRatio: layout.aspectRatio }}>
        <img
          src={sheetPageUrl(rosterId, crop.page)}
          alt={`Sheet line ${line}`}
          loading="lazy"
          decoding="async"
          draggable={false}
          style={{ top: `${layout.imgTopPct}%` }}
          onLoad={(e) => measure(e.currentTarget)}
          onError={() => setFailed(true)}
        />
        {layout.rowTopPct != null && (
          <>
            <span className="rs-crop-dim" aria-hidden="true" style={{ top: 0, height: `${layout.rowTopPct}%` }} />
            <span className="rs-crop-dim" aria-hidden="true" style={{ top: `${layout.rowBottomPct}%`, bottom: 0 }} />
          </>
        )}
      </span>
      <span id={hintId} className="rs-visually-hidden">Opens the page with this line highlighted</span>
    </button>
  );
}
